import React, { useState } from 'react';
import AddFunds from './addFunds';
import Addpayment from './addPayment';
import AddBank from './addPayment/AddBank';
import PointsConverter from './pointsConverter/PointsConverter';
import SendToFriend from './send';
import AddExisting from './add/Existing';
import {
    ChevronLeftIcon,
    SmallCloseIcon,
    Box,
    ToastProvider ,
} from 'native-base';
import {
    GIFTCARD_FLOWS,
    GiftCard,
    observer,
    useCreateGiftCardPayment,
    useI18n,
    useSpringBigStore,
    useTheme,
} from '@springbig/shared';
import SentMessage from './send/SentMessage';
import AddGiftCard from './add/Add';
import Pressable from '~/shared/Pressable';
import { useToast } from '~/hooks/toast';
import ManagePayment from './managePayment';
import CreditCardForm from '~/shared/CreditCardForm/CreditCardForm';
import { CreditCardDto } from '~/shared/CreditCardForm/hooks/useCreditCardForm';
import { Caption } from '~/shared/Typography';
import { ActionSheet } from '~/shared/Theme';

const ActionSheetContent = ({
    currentActionSheetItem,
    isOpen,
    currentFlow,
    manageGiftCard,
    data,
    setGiftCardValue,
    setIsCompletedModalOpen
}: {
    currentActionSheetItem: GIFTCARD_FLOWS,
    isOpen: boolean,
    currentFlow: GIFTCARD_FLOWS[],
    manageGiftCard: GiftCard | null,
    data: any,
    setGiftCardValue: (value: number) => void
    setIsCompletedModalOpen: (value: boolean) => void
}) => {

    const { member } = useSpringBigStore();
    const {
        mutate: createGiftCardPayment,
        isLoading,
    } = useCreateGiftCardPayment();
    const [addCardError, setAddCardError] = useState(null);

    const { giftCards } = useSpringBigStore();
    const onClose = () => {

        setIsConfirmState(false);
        observer.emit('close-actionsheet');
    };

    const { primary } = useTheme();

    const { t } = useI18n();
    const { successToast } = useToast();
    const [isConfirmState, setIsConfirmState] =
        useState(false);

    const onSubmitCreditCard = (creditCardDto: CreditCardDto): void => {

        member && createGiftCardPayment({
            member_id: member?.id.toString() || '',
            name: creditCardDto.name,
            number: creditCardDto.number,
            expiry: creditCardDto.expiry,
            cvv: creditCardDto.cvv,
            zip: creditCardDto.zip,
            payment_type: 'card'
        }, {
            onSuccess: () => {

                observer.emit('giftcard-back');
                observer.emit('giftcard-back');
            },
            onError: (error: unknown) => {

                setAddCardError([(error as { data: { message: string }}).data.message]);
            }
        });
    };

    const CurrentStep = () => {

        if (currentActionSheetItem === 'CONVERT_POINTS_TO_CASH' && !giftCards.length) {
            return <AddFunds
                manageGiftCard={manageGiftCard}
                t={t}
                successToast={successToast}
                isPurchaseWithPoints={true}
                setGiftCardValue={setGiftCardValue}
                setIsCompletedModalOpen={setIsCompletedModalOpen}
                isConfirmState={isConfirmState}
                setIsConfirmState={setIsConfirmState}
            />;
        }

        if (currentActionSheetItem === 'NULL' && isOpen) {
            onClose();
        }

        switch (currentActionSheetItem) {
        case GIFTCARD_FLOWS.addFunds:
            return <AddBank t={t} />;
            return <AddFunds
                manageGiftCard={manageGiftCard}
                t={t}
                successToast={successToast}
                isPurchaseWithPoints={false}
                setGiftCardValue={setGiftCardValue}
                setIsCompletedModalOpen={setIsCompletedModalOpen}
                isConfirmState={isConfirmState}
                setIsConfirmState={setIsConfirmState}
            />;
        case GIFTCARD_FLOWS.addPayment:
            return <Addpayment />;
        case GIFTCARD_FLOWS.addPaymentBank:
            return <AddBank t={t} />;
        case GIFTCARD_FLOWS.addPaymentCard:
            return <CreditCardForm
                onCancel={() => {}}
                onProceed={onSubmitCreditCard}
                showCancel={false}
                titleComponent={
                    <Box alignItems={'center'}>
                        <Caption
                            text={'credit_card.add_payment'}
                            fontSize={24}
                        />
                        <Caption
                            text={'giftCard.addPayment.addCard.caption'}
                            fontSize={20}
                            fontWeight={'200'}
                        />
                    </Box>
                }
                isLoading={isLoading}
                error={addCardError}
            />;
        case GIFTCARD_FLOWS.convertPointsToCash:
            return <PointsConverter t={t} />;
        case GIFTCARD_FLOWS.sentGift:
            return <SentMessage data={data} />;
        case GIFTCARD_FLOWS.sendGiftCard:
            return <SendToFriend t={t} />;
        case GIFTCARD_FLOWS.addGiftCard:
            return <AddGiftCard />;
        case GIFTCARD_FLOWS.existingGiftCard:
            return <AddExisting t={t} />;
        case GIFTCARD_FLOWS.managePayment:
            return <ManagePayment t={t} />;
        }
    };

    const IconManager = () => {

        if (currentActionSheetItem === GIFTCARD_FLOWS.addFunds && isConfirmState) {
            return <></>;
        }

        if (currentFlow.length > 1) {
            return <Pressable onPress={() => observer.emit('giftcard-back')}>
                <ChevronLeftIcon size={'lg'} color={primary} />
            </Pressable>;
        }

        return <Pressable onPress={onClose}>
            <SmallCloseIcon size={'lg'} color={primary} />
        </Pressable>;
    };

    return (
        <ActionSheet isOpen={isOpen} onClose={onClose} hideDragIndicator>
            <ToastProvider>
                <IconManager />
                { CurrentStep() }
            </ToastProvider>
        </ActionSheet>
    );
};

export default ActionSheetContent;
